import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgArrowDash2({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 40 19"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        d="M0 11.5h4v-4H0v4zm8 0h4v-4H8v4zm8 0h4v-4h-4v4zm8 0h4v-4h-4v4zM30.58.27a1 1 0 01.7.3l8.31 8.3a1 1 0 010 1.42l-8.3 8.3a1 1 0 01-1.7-.7V1.27a1 1 0 011-1z"
        fillRule="evenodd"
      />
    </svg>
  );
}

SvgArrowDash2.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgArrowDash2.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgArrowDash2 svgRef={ref} {...props} />);
export default ForwardRef;
